import client from './client';

// Email the wildfire incident PDF to a list of recipients. The server
// renders the PDF + sends one email per recipient, returning the
// notification ids written to the audit log.
//
// body: { recipients: ["broker@insurer.com", ...], note: "optional cover note" }
export const emailWildfireReport = (wildfireId, body) =>
  client
    .post(`/wildfires/${wildfireId}/email-report`, body)
    .then((r) => r.data);
